import { api } from './axios';
import type { ChangePasswordRequest, CurrentUser, LoginRequest } from '../types/auth';

export const authApi = {
  login: (req: LoginRequest) => api.post<CurrentUser>('/auth/login', req).then((r) => r.data),
  logout: () => api.post<void>('/auth/logout'),
  me: () => api.get<CurrentUser>('/auth/me').then((r) => r.data),
  changePassword: (req: ChangePasswordRequest) =>
    api.post<void>('/auth/change-password', req),
};
